import Vue from 'vue'
import vuetify from './vuetify'
import 'vue2-animate/dist/vue2-animate.min.css'
import router from './router'
import store from './store'
import App from './App'
import './Leaflet'
import moment from 'moment'
import 'moment/locale/sv'
import VueMoment from 'vue-moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './PNotify'
import authorization from './utils/authorization'

Vue.use(VueMoment, { moment })

// TODO: move API setup to own file
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = '/'

authorization.authorize()
store.dispatch('globalInfo/fetchGlobalInfo')

// Ensure we checked account/session before each page load.
router.beforeEach((to, from, next) => {
  const preloaders = [
    store.dispatch('account/fetchCurrentAccount'),
    store.dispatch('realEstate/preloadRealEstates'),
    store.dispatch('alarm/preloadAlarms'),
    store.dispatch('issues/preloadIssues')
  ]
  return Promise.all(preloaders).then(next).catch((e) => {
    if (localStorage.getItem('debug') === 'error') {
      console.log('error', e)
      return
    }
    localStorage.clear()
    location.href = '/'
  })
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js